'use strict';

module.exports = {
  template: require('./salary-invite.html'),
  controller: require('./salary-invite.controller'),
  controllerAs: 'vm',

  bindings: {
    me: '<',
    data: '<',
    round: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-invite/salary-invite/index.js
 ** module id = 194
 ** module chunks = 0
 **/